<template>
  <div
    class="wait-get-answer horizontal layout center center-justified"
    :class="{
      'quiz-has-img': hasClassQuizHasImage,
      'quiz-pick-ans--has-img': hasClassQuizPickAnswerHasImage || hasHints,
      'quiz-img-type-answer': slideActive.slideType == 'typeAnswer'
    }"
  >
    <button
      class="box-wait horizontal layout center btn btn-primary"
      :style="{'background-color': boxWaitBg}"
      v-show="isTimeBoxAndEndQuizButtonVisible"
      @click="handleEndQuiz()"
      @mouseenter="trackGAHoverOnBoxWait"
    >
      <div
        class="time-down countdown-ring-wrapper"
        :class="{'hide-color': hasClassHideColor}"
      >
        <div id="countdown-wait-answer">
          <svg v-if="!isEndingQuiz">
            <circle
              r="15"
              cx="20"
              cy="20"
              :style="{'animation': animationTimeToAnswer}"
            />
            <rect
              x="14.092041"
              y="14.01855"
              width="12"
              height="12"
              rx="1.08817"
              fill="#6298EB"
              class="end-quiz__rectangle"
            />
          </svg>
          <aha-spinner
            size="md"
            variant="tail"
            v-if="isEndingQuiz"
          />
        </div>
      </div>
      <div
        class="count-down-answer horizontal layout center"
        v-show="isTimeUntilVotingCloseVisible"
      >
        <span id="timeLeftToAnswer" class="count-down__text" />
        <span
          class="end-quiz__text"
          :class="{'dark-theme': isWhiteTextColour}"
        >{{ $t('End now') }}</span>
      </div>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import EventBus from '@/eventBus'
import constants from '@/constant'
import Socket from '@/socket'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

import SlideApi from '@/api/slide'

export default {
  props: {
    countTimeToAnswer: {
      type: Number,
      default: 0,
    },
    everyoneVoted: {
      type: Boolean,
      default: false,
    },
    animationTimeToAnswer: {
      type: String,
      default: 'countdown-wait 5s linear forwards',
    },
    boxWaitBg: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      QuizStatuses: constants.QuizStatuses,
      isEndingQuiz: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
      presentation: (state) => state.presentation,
    }),
    hasClassQuizHasImage() {
      const { slideType, image, hideResult } = this.slideActive
      return slideType == 'imageChoice' && image && hideResult && this.countTimeToAnswer > 3
    },
    hasClassQuizPickAnswerHasImage() {
      const { slideType, image, hideResult } = this.slideActive
      return !slideType && image && hideResult && this.countTimeToAnswer > 3
    },
    isPickAnswerSlideType() {
      return this.slideActive.type === 'pickAnswer' && !this.slideActive.slideType
    },
    hasHints() {
      return this.slideActive.isHintsVisible && this.slideActive.hints &&
        this.slideActive.hints.length && this.slideActive.hints.some((hint) => hint.id)
        && this.isPickAnswerSlideType
    },
    hasClassHideColor() {
      return !this.countTimeToAnswer || this.countTimeToAnswer < 0
    },
    isQuizQuestionScreen() {
      return this.slideActive.quizStatus == this.QuizStatuses.QUESTION_SCREEN
    },
    isTypeAnswerSlide() {
      return this.slideActive.type == 'pickAnswer' && this.slideActive.slideType == 'typeAnswer'
    },
    isTimeBoxAndEndQuizButtonVisible() {
      return !this.everyoneVoted && this.isQuizQuestionScreen && this.countTimeToAnswer > 3
    },
    isTimeUntilVotingCloseVisible() {
      return this.countTimeToAnswer && this.countTimeToAnswer > 0 && !this.everyoneVoted
    },
    isWhiteTextColour() {
      return this.slideActive.textColour === '#ffffff'
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    trackGAHoverOnBoxWait() {
      utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Quiz time remaining box > Hover > Show end quiz option',
      )
    },
    handleEndQuiz() {
      if (this.sharePresentation || this.presentation.audiencePacing) {
        return
      }
      this.isEndingQuiz = true
      this._updateSlide({
        socketId: Socket.getSocketId(),
        accessCode: this.presentation.uniqueAccessCode,
        presentationId: this.presentation.id,
        presenting: this.isPresenting || this.isBackstage,
        quizStatus: constants.QuizStatuses.RESULT_SCREEN,
        showCorrectOption: true,
      })
      utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Quiz time remaining box > End quiz',
      )
    },
    async _updateSlide(payload) {
      try {
        await SlideApi.updateSlideById(this.slideActive.id, payload)
        this.isEndingQuiz = false
        if (this.isTypeAnswerSlide) {
          EventBus.$emit('eventShowQuizTypeAnswer')
        }
        this.updateSlideActiveAction({
          showCorrectOption: true,
          hideResult: false,
          quizStatus: constants.QuizStatuses.RESULT_SCREEN,
        })
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wait-get-answer {
  color: inherit;
  border: none;
  padding: 0.75rem;
  position: absolute;
  width: 100%;
  top: 30%;
  left: 0;
  z-index: 10;
  &.quiz-has-img {
    top: 39%;
  }
  &.quiz-pick-ans--has-img {
    top: 46%;
  }
  &.quiz-img-type-answer {
    top: 46%;
  }

  .box-wait {
    border-radius: 60px;
    &.btn-primary:not(:disabled):not(.disabled):active,
    .btn-primary:not(:disabled):not(.disabled).active {
      color: inherit;
      box-shadow: 0px 0px 0px 8px rgba(0,0,0,.1);
    }
  }
}
.box-wait {
  border-radius: 5px;
  margin: 0 16px;
  font-weight: bold;
  color: inherit;
  border: none;
  padding: 10px;
  cursor: default;
  font-size: 1.2em;
  cursor: pointer;
  min-width: 152px;
  &:hover {
    .end-quiz__rectangle, .end-quiz__text {
      opacity: 1;
      color: #313131;
      &.dark-theme {
        color: #ffffff;
      }
    }
    .count-down__text {
      opacity: 0;
    }
  }

  .end-quiz__rectangle, .end-quiz__text {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  .time-down {
    margin-right: 8px;
    padding: 1px;
    opacity: 1;
    border-radius: 100%;

    &.hide-color {
      background-color: transparent;
    }
  }
}
.count-down-answer {
  display: flex;
  align-items: center;
  justify-content: center;
  .count-down__text {
    font-size: 1.4em;
    position: absolute;
  }
  .end-quiz__text {
    font-size: 0.85em;
    max-width: 7.75rem;
  }
}
</style>
